import Board from "../Components/board/Board"

const BoardPage=()=>{
  return (
    <Board/>
  )
}
export default BoardPage